//import { useState } from 'react';

function Jumbotron({ jumbs }) {

  return (
    <section className="jumbotron">
        <div className="jumbotron-content">
          <h2>Enjoy the best Audio Content</h2>
          <div className="card-slide">
            <div className="slider">

            {
                jumbs.map((jumb, index) => (
                  <div className="card jb-card" key={index}>
                    <div className="content">
                        <p>{ jumb.title }</p>
                        <small>- { jumb.artist } </small>
                    </div>
                    <img src={ jumb.cover } alt={ jumb.title }/>
                </div>
                ))
            }
          </div>
            <div className="thumb"></div>
          </div>
          <p>Stream all latest songs in high quality</p>
        </div>
    </section>
  );
}

export default Jumbotron;